<template>
  <div class="w-full">
    <div class="mt-2 px-4 bg-neutral-secondary rounded-md">
      <div class="flex justify-between items-center py-3">
        <NText variant="caption1" weight="medium">
          {{ t('common.symbol') }}
        </NText>

        <NText variant="caption1" weight="medium" class="pr-2">
          {{ symbol.name }}
        </NText>
      </div>

      <div class="flex justify-between items-center pb-3">
        <NText variant="caption1" weight="medium">
          {{ t('option.applicationRegistrationDate') }}
        </NText>

        <div>
          <NText variant="caption1" weight="medium" class="align-middle">
            {{ d(symbol.requestDate, 'shortDate') }} ,
          </NText>
          <NText variant="caption1" weight="medium" class="align-middle ms-1">
            {{ d(symbol.requestDate, 'shortTime') }}
          </NText>
        </div>
      </div>

      <div class="flex justify-between items-center pb-3">
        <NText variant="caption1" weight="medium">
          {{ t('common.requestStatus') }}
        </NText>

        <NText variant="caption1" weight="medium">
          {{ symbol.requestState }}
        </NText>
      </div>

      <div v-if="symbol.description" class="flex justify-between pb-3">
        <NText variant="caption1" weight="medium">
          {{ t('common.description') }}
        </NText>

        <NText variant="caption1" weight="medium" class="mr-4">
          {{ symbol.description }}
        </NText>
      </div>

      <div class="flex justify-between pb-3">
        <NText variant="caption1" weight="medium">
          {{ t('deposit.requestCode') }}
        </NText>

        <NText variant="caption1" weight="medium" class="mr-4">
          {{ symbol.requestId }}
        </NText>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FrozenHistoryItem } from '@libs/api-reference';
import { useI18n } from 'vue-i18n';

type TFreezeInfoDialogProps = {
  symbol: FrozenHistoryItem;
};

defineProps<TFreezeInfoDialogProps>();

const { t, d } = useI18n();
</script>
